import { render, staticRenderFns } from "./at.vue?vue&type=template&id=5061f6f2&scoped=true&"
import script from "./at.vue?vue&type=script&lang=js&"
export * from "./at.vue?vue&type=script&lang=js&"
import style0 from "./at.vue?vue&type=style&index=0&id=5061f6f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5061f6f2",
  null
  
)

export default component.exports